import { useEffect, useState } from 'react';

// unsure of the specific reason that 100 was chosen here but all consumers of this hook are using
// it so default it and prevent consumers from having to redefine the same 100 value everywhere.
const DEFAULT_DURATION = 100;

// FIXME(Yuri): Fix type and add condition for undefined
// https://github.com/vercel/next.js/discussions/18991
/**
 * @param {string} testId
 * @param {number} duration
 * @param {boolean} getIsInitialized
 * @returns {(string | null | {variant: string | null, isInitialized: boolean})}
 */
export function useGoogleOptimize(testId, duration = DEFAULT_DURATION, getIsInitialized = false) {
  const [variant, setVariant] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google_optimize !== undefined) {
        const variantValue = window.google_optimize.get(testId);
        if (typeof variantValue !== 'undefined') {
          setVariant(variantValue);
        }
        setIsInitialized(true);
        clearInterval(interval);
      }
    }, duration);

    if (typeof window !== 'undefined') {
      window.addEventListener('google_optimize.ready', () => {
        clearInterval(interval);
        const variantValue = window.google_optimize.get(testId);
        if (typeof variantValue !== 'undefined') {
          setVariant(variantValue);
        }
        setIsInitialized(true);
      });
    }

    return () => clearInterval(interval);
  }, []);

  return getIsInitialized ? { isInitialized, variant } : variant;
}

/**
 * @param {string} testId
 */
export function checkActiveExperiment(testId) {
  window.dataLayer.push('event', 'optimize.callback', {
    name: testId,
    callback: (value, name) =>
      // eslint-disable-next-line no-console
      console.log(`Experiment with ID: ${name} is on variant: ${value}`),
  });
}
